import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import {
	OverviewIntegrationOption,
	integrationsConfig,
} from "../../../../components/Home/Overview/Integrations/OverviewIntegrations";
import BriaTooltip from "../../../../components/common/BriaTooltip/BriaTooltip";
import { IntegrationIconCard } from "../../../../components/common/IntegrationIconCard/IntegrationIconCard.tsx";
import styles from "./ProductsWidgetIntegrations.module.scss";

const groupedIntegrations: { title: string; options: OverviewIntegrationOption[] }[] = [
	{
		title: "payWith",
		options: ["AWS", "AZURE"],
	},
	{
		title: "findUs",
		options: ["FAL", "HUGGING_FACE", "GITHUB", "REPLICATE"],
	},
	{
		title: "integrateWith",
		options: ["API", "MCP", "IFRAME"],
	},
	{
		title: "useIn",
		options: ["COMFY_UI", "INVOKE", "CLAUDE", "FIGMA", "PHOTOSHOP"],
	},
];

const ProductsWidgetIntegrations = () => {
	const { t } = useTranslation("dashboard", { keyPrefix: "products.integrate" });

	return (
		<Box>
			<Box className={styles.header}>
				<Typography className={styles.title}>{t("title")}</Typography>
				<Typography className={styles.description}>{t("description")}</Typography>
			</Box>

			<Box className={styles.integrations}>
				{groupedIntegrations.map((group) => (
					<Box key={group.title} className={styles.group}>
						<Typography className={styles.groupTitle}>{t(`groups.${group.title}`)}</Typography>
						<Box className={styles.groupOptions}>
							{group.options.map((integration) => (
								<BriaTooltip title={t(`integrations.${integration}.label`)}>
									<IntegrationIconCard key={integration} {...integrationsConfig[integration]} />
								</BriaTooltip>
							))}
						</Box>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default observer(ProductsWidgetIntegrations);
